function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import * as actionTypes from './actionTypes';
// TODO: Pivot report config flags. They should be grouped by report type. Probably the best way is to create generic
//  and polymorphic config object for registering any report config flags on the fly. Alternatively it can be based
//  on the form system.
const initialState = {
    menuOpen: false,
    selectedMenuItem: null,
    agpView: false,
    hideReadingsTable: false,
    hideDailyDetails: false,
    hideEmptyRows: false,
    showDayDividers: false,
    fetching: [],
    sending: [],
    errors: [],
    windowWidth: 0
};
export default function reducer(state = _object_spread({}, initialState), action = {}) {
    switch(action.type){
        case actionTypes.SET_MENU_OPEN:
            {
                const { menuOpen } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    menuOpen
                });
            }
        case actionTypes.SET_SELECTED_MENU_ITEM:
            {
                const { selectedMenuItem } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    selectedMenuItem
                });
            }
        case actionTypes.SET_AGP_VIEW:
            {
                const { agpView } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    agpView
                });
            }
        case actionTypes.SET_WINDOW_WIDTH:
            {
                const { windowWidth } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    windowWidth
                });
            }
        case actionTypes.SET_HIDE_READINGS_TABLE:
            {
                const { hideReadingsTable } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    hideReadingsTable
                });
            }
        case actionTypes.SET_HIDE_DAILY_DETAILS:
            {
                const { hideDailyDetails } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    hideDailyDetails
                });
            }
        case actionTypes.SET_HIDE_EMPTY_ROWS:
            {
                const { hideEmptyRows } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    hideEmptyRows
                });
            }
        case actionTypes.SET_SHOW_DAY_DIVIDERS:
            {
                const { showDayDividers } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    showDayDividers
                });
            }
        default:
            {
                return state;
            }
    }
}
